import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { messages } from '../../../../../messages';
export const BackButton = ({
  backButtonOnClick,
  backButtonAppearance,
  isSubmissionLoading,
  backButtonText,
  testId
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Button, {
    testId: `${testId}-footer-back-button`,
    onClick: backButtonOnClick,
    appearance: backButtonAppearance,
    isDisabled: isSubmissionLoading
  }, backButtonText || formatMessage(messages.defaultBackButtonText));
};